import React from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "components/CustomButtons/Button.js";
import PersonAddIcon from "@material-ui/icons/PersonAdd";

import CustomInput from "components/CustomInput/CustomInput.js";
import CardForms from "components/Card/CardForms.jsx";
import useForm from "../../hooks/useForm";


const SearchFormClients = ({ handleSearchClient }) => {
  const [formulario, handleChange,reset] = useForm({
    numeroCliente: "",
    nombres: "",
    apellidoP: "",
    apellidoM: "",
    claveElector: ""
  });


  const handleSubmit = e => {
    e.preventDefault();
    if (typeof handleSearchClient === "function") {
      handleSearchClient(formulario);
    }
  };


  const handleButtonLimpia = e => {
    e.preventDefault();
    reset();
  };

  const handleNuevoCliente = () => {
    sessionStorage.setItem("retorno_contrato", "true");
    window.location.href = "/admin/ConsultaCliente";
  };


  return (
    <CardForms title="Buscar cliente">
      <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
        Busca un cliente existente o registra uno nuevo
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <CustomInput
            labelText={"Número del cliente"}
            name="numeroCliente"
            type="number"
            onChange={handleChange}
            formControlProps={{ fullWidth: true }}
            labelProps={{ required: true }}
            inputProps={{ maxLength: 50 }}
            attributes={{ value: formulario.numeroCliente }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CustomInput
            labelText={"Nombre"}
            name="nombres"
            onChange={handleChange}
            formControlProps={{ fullWidth: true }}
            inputProps={{ maxLength: 50 }}
            attributes={{ value: formulario.nombres }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CustomInput
            labelText={"Apellido paterno"}
            name="apellidoP"
            onChange={handleChange}
            formControlProps={{ fullWidth: true }}
            inputProps={{ maxLength: 50 }}
            attributes={{ value: formulario.apellidoP }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <CustomInput
            labelText={"Apellido materno"}
            name="apellidoM"
            onChange={handleChange}
            formControlProps={{ fullWidth: true }}
            inputProps={{ maxLength: 50 }}
            attributes={{ value: formulario.apellidoM }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <CustomInput
            labelText={"Clave de elector"}
            name="claveElector"
            onChange={handleChange}
            formControlProps={{ fullWidth: true }}
            inputProps={{ maxLength: 18 }}
            attributes={{ value: formulario.claveElector }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ marginTop: 8 }}>
        <Grid item>
          <Button onClick={handleSubmit} color="success">
            Consultar
          </Button>
        </Grid>
        <Grid item>
          <Button onClick={handleButtonLimpia}>
            Limpiar
          </Button>
        </Grid>
        <Grid item>
          <Button onClick={handleNuevoCliente} color="info">
            <PersonAddIcon style={{ marginRight: 4 }} /> Cliente nuevo
          </Button>
        </Grid>
      </Grid>
    </CardForms>
  );
};

SearchFormClients.propTypes = {
  handleSearchClient: PropTypes.func
};
export default SearchFormClients;
